import { render } from "./UserOrders.vue?vue&type=template&id=bbdee66a&scoped=true&ts=true"
import script from "./UserOrders.vue?vue&type=script&lang=ts"
export * from "./UserOrders.vue?vue&type=script&lang=ts"

import "./UserOrders.vue?vue&type=style&index=0&id=bbdee66a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbdee66a"]])

export default __exports__